<template>
  <div ref="root" class="w-full space-y-6 opacity-0 transition">
    <button
      v-for="thumbnail in thumbnails"
      :key="thumbnail.pageNumber"
      :data-page-number="thumbnail.pageNumber"
      :disabled="thumbnail.pageNumber === currentPage"
      class="group flex flex-col items-center space-y-2"
      @click="gotoPage"
    >
      <img
        :src="thumbnail.url"
        class="w-full group-disabled:ring-2 group-disabled:ring-blue-500"
        @contextmenu.prevent
      />
      <div class="font-sm text-white">
        {{ thumbnail.pageNumber }}
        <span v-if="isScoreVisible && thumbnail.score !== undefined" class="text-xs">
          (Score: {{ parseFloat(thumbnail.score).toFixed(3) }})
        </span>
      </div>
    </button>
  </div>
</template>

<script setup>
import { computed, inject, onMounted, ref, watch } from "vue"

// hooks
const { isThumbnailsVisible, currentPage } = inject("CONTROL_STATE")
const { thumbnails, gotoPage } = inject("THUMBNAILS_STATE")
const { isOnlyShowAttributeSourcePages } = inject("VIEWER_STATE")

// dom ref
const root = ref(null)

// computed
const areScoresAvailable = computed(() =>
  thumbnails.value.some(thumbnail => thumbnail.score !== undefined && thumbnail.score)
)
const isScoreVisible = computed(() => isOnlyShowAttributeSourcePages.value && areScoresAvailable.value)

// methods
const toggleThumbnailsVisibility = () => {
  const rootElement = root.value
  if (!rootElement) return

  if (isThumbnailsVisible.value) {
    setTimeout(() => {
      rootElement.classList.remove("opacity-0")
    }, 150)
  } else {
    setTimeout(() => {
      rootElement.classList.add("opacity-0")
    }, 150)
  }
}

// lifecycle
onMounted(() => {
  toggleThumbnailsVisibility()
})

// watchers
watch(isThumbnailsVisible, () => toggleThumbnailsVisibility(), { immediate: true })
</script>
